function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var $ = jQuery;
var Pin = /*#__PURE__*/function () {
  function Pin(model, tooltipSettings) {
    var generalSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Pin);
    this.model = model;
    this.map = null;
    this.mouseover = false;
    this.visibilityConditions = {
      tag: true,
      search: true,
      base: !generalSettings.hideInitially
    };

    // Add a utility image object if the pin has an image
    var pinImage = null;
    if (this.model.image.url) {
      pinImage = new Image();
      pinImage.src = this.model.image.url;
    }
    this.image = pinImage;

    // Add a tooltip to the pin
    var tooltip = null;
    if (this.model.tooltipEnabled) {
      tooltip = new MapifyTooltip({
        classes: 'mpfy-tooltip ' + tooltipSettings.classes,
        rgba: tooltipSettings.background,
        content: tooltipSettings.content,
        close_behavior: tooltipSettings.closeBehavior,
        animate: tooltipSettings.animate,
        pinId: tooltipSettings.pinId
      });
    }
    this.tooltip = tooltip;
  }
  _createClass(Pin, [{
    key: "isVisible",
    value: function isVisible() {
      for (var option in this.visibilityConditions) {
        var condition = this.visibilityConditions[option];
        if (!condition) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(condition, visible) {
      this.visibilityConditions[condition] = visible;
    }
  }]);
  return Pin;
}();
;
module.exports = Pin;